import React, { Component } from "react";
import "../Styles/About.css";

class About extends Component {
  render() {
    return (
      <div id="about">
        <h1>About US</h1>
        <div className="about-container">
          <div className="about-1">
            <p>
            We extend our dedication to various other aspects of your journey. From personalized itineraries to concierge services, guided tours to curated experiences, we aim to exceed your expectations at every turn. Our goal is to provide a comprehensive suite of services that anticipates your needs, ensuring an unforgettable and seamless travel experience from beginning to end.
            </p>
          </div>
          <div className="about-2">
            <p> Our smart booking engine searches for for the best price, car category, extras, exclusive offers and discounts suiting your needs. You can securely book online today only with a small downpayment and pay the rest upon your arrival at the desk!</p>
          </div>
          <div className="about-3">
            <p>We had provided millions of customers with the best possible guaranteed price for journey. We welcome you to become our next satisfied customer.</p>
          </div>
        </div>
<h2>SUV</h2>
        <div className="about-SUV">
          <div >
            <img src="https://imgd.aeplcdn.com/664x374/n/cw/ec/40432/scorpio-n-exterior-right-front-three-quarter-75.jpeg?isig=0&q=80" alt=""></img>
            <h3>Mahindra Scorpio N</h3>

          </div>
          <div>
            <img src="https://imgd.aeplcdn.com/664x374/n/cw/ec/40087/thar-exterior-right-front-three-quarter-35.jpeg?isig=0&q=80"alt=""></img>
            <h3>Mahindra Thar</h3>
          </div>
          <div>
            <img src="https://eliteblackcarservices.com/wp-content/uploads/2018/01/ford-expedition-XLT.jpg" alt=""></img>
            <h3>FORD EXPEDITION XLT</h3>
          </div>
          <div>
            <img src="https://imgd-ct.aeplcdn.com/393x221/n/cw/ec/44709/fortuner-exterior-right-front-three-quarter-20.jpeg?isig=0&q=80" alt=""></img>
           <h3>Toyota Fortuner</h3>
          </div>
          <div>
            <img src="https://imgd.aeplcdn.com/370x208/n/cw/ec/126681/nexon-ev-prime-exterior-right-front-three-quarter-2.gif?isig=0&q=80" alt=""></img>
           <h3>Nexon</h3>
          </div>
         
        </div>
        <h2>JEEP</h2>

        <div className="about-Jeep">
        <div >
            <img src="https://imgd.aeplcdn.com/664x374/n/cw/ec/54437/wrangler-exterior-right-front-three-quarter-52.jpeg?isig=0&q=80" alt=""></img>
            <h3>Wrangler</h3>

          </div>
          <div>
            <img src="https://www.carandbike.com/_next/image?url=https%3A%2F%2Fi.ndtvimg.com%2Fi%2F2017-11%2Fmahindra-scorpio-facelift_827x510_41510648738.jpg&w=2048&q=75"alt=""></img>
            <h3>Scorpio</h3>
          </div>
          <div>
            <img src="https://cdni.autocarindia.com/Utils/ImageResizer.ashx?n=https://cms.haymarketindia.net/model/uploads/modelimages/Mahindra-Bolero-050820211908.jpg&w=373&h=245&q=75&c=1" alt=""></img>
            <h3>Bolero</h3>
          </div>
          <div>
            <img src="https://www.fraserway.com/dw/image/v2/BHGF_PRD/on/demandware.static/-/Sites-fraserway-master-catalog/default/dwc254f0f5/images/rentals/Van%20Conversion/Thor%20Van%20ConversionLanding%20Page%201060x680.png?sw=1060&sh=680" alt=""></img>
           <h3>RV Van</h3>
          </div>
         
        </div>
        <h2>CAB</h2>

        <div className="about-Cab">
        <div >
            <img src="https://5.imimg.com/data5/SELLER/Default/2021/1/FR/ZB/RJ/61679842/tour-h1-png.png" alt=""></img>
            <h3>Suzuki Alto</h3>

          </div>
          <div>
            <img src="https://thehimalayantimes.com/uploads/imported_images/wp-content/uploads/2015/08/Pg-9-ShortCuts-2.jpg"alt=""></img>
            <h3>Hyundai Eon</h3>
          </div>
          
          
        </div>
        <h2>BIKES</h2>

        <div className="about-bike">
        <div >
            <img src="https://classifiedsonline.com.np/public/images/listings/20210910-1631266539-282-1-auto.jpg" alt=""></img>
            <h3>Royal Enfield Himayan</h3>

          </div>
          <div>
            <img src="https://m.media-amazon.com/images/W/MEDIAX_792452-T2/images/I/71oNbZeckpL._AC_UF894,1000_QL80_.jpg"alt=""></img>
            <h3>Dot bike 250</h3>
          </div>
          <div>
            <img src="https://reviews.com.np/uploads/article/bajaj-pulsar-220-price-in-nepal-full-specification/bajaj-pulsar-220-price-in-nepal-full-specification.jpg" alt=""></img>
            <h3>Pulsar 220</h3>
          </div>
          <div>
            <img src="https://5.imimg.com/data5/FV/OA/MY-50536557/aprilia-sr-150-base-500x500.jpg" alt=""></img>
           <h3>Aprila</h3>
          </div>
          <div>
            <img src="https://www.yadea.com.np/wp-content/uploads/2021/01/Frame-11.png" alt=""></img>
           <h3>Yadea</h3>
          </div>
          </div>

      </div>
    );
  }
}

export default About;
